import z from "zod";

import { ENG_ARABIC_NAME_REGEX } from "@/utils/constants/arabicRegex";

const phoneRegex = /^[0-9\s\-()+]+$/;

export const FormSchemaUserProfile = z
  .object({
    firstName: z
      .string()
      .min(1, { message: "This field is required" })
      .max(100, { message: "Maximum length is 100 characters" })
      .regex(ENG_ARABIC_NAME_REGEX, {
        message: "Only English and Arabic letters allowed",
      }),
    lastName: z
      .string()
      .min(1, { message: "This field is required" })
      .max(100, { message: "Maximum length is 100 characters" })
      .regex(ENG_ARABIC_NAME_REGEX, {
        message: "Only English and Arabic letters allowed",
      }),
    phoneCode: z.string().min(1, { message: "Select a country code" }),
    phoneNumber: z
      .string()
      .min(1, { message: "Phone number is required." })
      .refine(val => phoneRegex.test(val), {
        message: "Only digits and common separators allowed",
      }),

    phone: z.string().optional(),
    email: z
      .string()
      .min(1, { message: "This field is required" })
      .email({ message: "Enter a valid email" }),
  })
  .superRefine((data, ctx) => {
    if (data.phoneCode || data.phoneNumber) {
      const digitsOnly =
        (data.phoneCode?.replace(/\D/g, "") ?? "") +
        (data.phoneNumber?.replace(/\D/g, "") ?? "");
      if (digitsOnly.length > 15) {
        ctx.addIssue({
          path: ["phoneNumber"],
          code: z.ZodIssueCode.custom,
          message: "Phone number must be under 15 characters including code",
        });
      }
    }
  });

export type ProfileFormUserType = z.infer<typeof FormSchemaUserProfile>;
